/**
 * VÉRAULT Portal — Advisor: Overview / Atelier (Wave 26.19c)
 * ============================================================
 * The advisor's landing room is now the operational command center
 * powered by AdvisorOverviewComposite. The old MorningBrief / Weekly
 * Rhythm / Insights / CommandCenter widgets still exist for opt-in
 * deep-link views but the default homepage is the new composite.
 */
import React from "react";
import AdvisorOverviewComposite from "./AdvisorOverviewComposite";

export default function AdvisorAtelier() {
  return <AdvisorOverviewComposite />;
}
